export default "__VITE_ASSET__CwXkubHj__"